<div class="contact-form-container">
  <form #ContactForm="ngForm">
    <div class="field-row">
      <rms-input name="FirstName" label="First Name" [(ngModel)]="Contact.FirstName"></rms-input>
      <rms-input name="LastName" label="Last Name" [(ngModel)]="Contact.LastName"></rms-input>
      <rms-input name="Email" label="Email" [(ngModel)]="Contact.Email"></rms-input>
      <rms-input name="Phone" label="Phone" [(ngModel)]="Contact.Phone"></rms-input>
    </div>
    <rms-multi-select name="Roles" label="Roles" [options]="RoleOptions" [(ngModel)]="Contact.RoleIDs"></rms-multi-select>
    <fieldset class="rms-fieldset">
      <legend>Communication Preferences</legend>
      <div class="field-row">
        <rms-checkbox name="IsInvoiceRecipient" label="Invoice Recipient" [(ngModel)]="Contact.IsInvoiceRecipient"></rms-checkbox>
        <rms-checkbox name="IsConfirmationRecipient" label="Confirmation Recipient" [(ngModel)]="Contact.IsConfirmationRecipient"></rms-checkbox>
        <rms-checkbox name="IsProNotificationRecipient" label="PRO Recipient" [(ngModel)]="Contact.IsProNotificationRecipient"></rms-checkbox>
      </div>
    </fieldset><p class="form-help">Enter a name or email. Notification recipients require a valid email address.</p>
    <rms-checkbox name="IsActive" label="Active" [(ngModel)]="Contact.IsActive"></rms-checkbox>
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!ContactForm.valid || !canSave" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
